import React, { useEffect, useRef, useState } from 'react';
import { Tooltip } from '@material-ui/core';

const HoverTooltip = (props) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const ref = useRef();
  useEffect(() => {
    if (props.domElement) {
      ref.current.appendChild(props.domElement);
    }
  }, []);

  return (
    <span
      className="hover-tooltip"
      style={{
        verticalAlign: 'inherit',
        display: 'inline-block',
        ...(props.style ?? {}),
      }}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <Tooltip title={props.title} open={showTooltip}>
        {!props.children ? <span ref={ref}></span> : props.children}
      </Tooltip>
    </span>
  );
};

export default HoverTooltip;
